import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import { OnlineSales } from 'gw-edge-client';

export function useSetCarReplacement(): {
    setCarReplacement: (sourceCarFixedId: string, targetCarFixedId: string) => Promise<void>;
} {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const setCarReplacement = async (
        sourceCarFixedId: string,
        targetCarFixedId: string
    ): Promise<void> => {
        await OnlineSales.setCarReplacement(
            jobNumber,
            sessionId,
            sourceCarFixedId,
            targetCarFixedId
        );
    };

    return { setCarReplacement };
}
